
// React
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Libraries

// Components
import DatePickerInput from 'ui/components/DatePickerInput'

// Shared
import moment from 'shared/lib/moment'

/**
 * TimeInput: Wrapper to allow using DateTimePicker for
 * picking pure time values with no associated date
 *
 * @example
 *   <TimeInput
 *     field={{ value: "12:00", onChange: () => {} }}
 *     format="HH:mm A"
 *   />
 */

class TimeInput extends React.Component {
  static displayName = 'TimeInput'

  static propTypes = {
    format: PropTypes.string,
    field: PropTypes.object,
    useAmPm: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.bool]),
    clearable: PropTypes.bool
  }

  static defaultProps = {
    field: {},
    clearable: true
  }

  formatValue = () => {
    // We need a valid date to pass to DatePicker
    const fakeTime = moment(`2000-01-01 ${this.props.field.value}`)

    return fakeTime.toISOString()
  }

  onChange = (value) => {
    // Convert date back into hours
    const date = moment(value)

    this.props.field.onChange(`${date.format('HH:mm')}`)
  }

  render () {
    const { field, format, useAmPm, error, clearable } = this.props

    const timeFormat = format ||
      useAmPm ?
      'hh:mm A' :
      'HH:mm'
    const value = this.formatValue()

    const fieldProps = {
      onChange: this.onChange,
      onBlur: field.onBlur,
      value: value
    }

    return (
      <DatePickerInput
        timeOnly
        format={timeFormat}
        field={fieldProps}
        error={error}
        clearable={clearable}
      />
    )
  }
}

const mapStateToProps = (state) => ({ useAmPm: state.settings.get('dates.use_am_pm') })

const ConnectedTimeInput = connect(mapStateToProps)(TimeInput)

export default ConnectedTimeInput
